import { Component, OnInit } from '@angular/core';
import {AnalyticsService} from '../../../../services/analytics/analytics.service';
import {CustomerCampaignService} from '../../../../services/customer/customer-campaign.service';
import {SearchToolbarModelFactoryService} from '../../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';
import {SearchToolbarDateFunction, SearchToolbarFactoryParameters, SearchToolbarFilterWindow, SearchToolbarSection} from '../../../../models/search-toolbar-factory-parameters.model';
import {IndicatorsChartService, IndicatorsService} from '../../../../services/indicators/indicators.service';
import {IndicatorBoxModel} from '../../../../models/indicator-box.model';
import {QFilterModel} from '../../../../models/qfilter.model';
import {TranslateService} from '@ngx-translate/core';
import {IndicatorsSearchToolbarModel} from '../../../../models/indicators-search-toolbar-model.model';
import {LoyaltyChart} from '../../../../models/loyalty-chart-config.model';

@Component({
  selector: 'app-store-customers-overview',
  templateUrl: './store-customers-overview.component.html',
  styleUrls: ['./store-customers-overview.component.css']
})
export class StoreCustomersOverviewComponent implements OnInit {


  public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();
  public indicators: IndicatorBoxModel[] = [];

  translations: any;

  incidenzaChart: LoyaltyChart;
  scontrinoMedioChart: LoyaltyChart;

  public data: QFilterModel;

  constructor(
    private indicatorService: IndicatorsService,
    private chartsService: IndicatorsChartService,
    private svcAnalytics: AnalyticsService,
    private srvCustomerCampaign: CustomerCampaignService,
    private translate: TranslateService,
    private searchModelFactory: SearchToolbarModelFactoryService,
  ) {
    this.translate.get([
      'loyalty_chart.fatturato',
      'loyalty_chart.penetrazioneCarta'
    ]).subscribe((t) => {
      this.translations = {
        indicenzaChartTitle: t['loyalty_chart.fatturato'],
        scontrinoMedioChartTitle: t['loyalty_chart.penetrazioneCarta']
      };
    });

    this.initCharts();
  }

  initCharts() {
    this.incidenzaChart = (new LoyaltyChart('line'));

    this.scontrinoMedioChart = new LoyaltyChart('line');
  }

  ngOnInit() {
    const searchParams: SearchToolbarFactoryParameters = new SearchToolbarFactoryParameters();
    searchParams.svcAnalytics = this.svcAnalytics;
    searchParams.dateFunctionType = SearchToolbarDateFunction.VaDates;
    searchParams.finestra = SearchToolbarFilterWindow.Week;
    searchParams.disabledSections = [SearchToolbarSection.CardModes, SearchToolbarSection.Clusterlist, SearchToolbarSection.GroupTypes, SearchToolbarSection.Areas ];

    this.searchModelFactory.buildSearchToolbarModel(searchParams).subscribe((model) => {
      this.searchModel = model;
    });
  }

  setChartInstance(chart: LoyaltyChart, chartInstance) {
    chart.instance = chartInstance;
  }

  searchValueTrend(data: QFilterModel) {
    this.data = data;

    this.translate.get([
      'indicator.fatturato',
      'indicator.scontrini',
      'indicator.fatturato_mq',
      'indicator.scontrino_medio',
      'indicator.media_clienti_settimanali',
      'indicator.incidenza_carta',
      'indicator.incidenza_promo',
      'indicator.nuovi_clienti',
      'indicator.pct_clienti_target'
    ]).subscribe(t => {
      this.indicators = [];
      this.indicatorService.indicatorCalculation('stores.Q077', this.data).switchMap((res) => {

        this.indicators.push(new IndicatorBoxModel([res[0]], {}, t));
        this.indicators.push(new IndicatorBoxModel([res[1]], {}, t));

        return this.indicatorService.indicatorCalculation('stores.Q084', this.data);
      }).switchMap((res) => {
        this.indicators.push(new IndicatorBoxModel(res, {}, t));
        return this.indicatorService.indicatorCalculation('stores.Q105', this.data);
      }).subscribe((res) => {
        this.indicators.push(new IndicatorBoxModel(res, {}, t));
      });
    });

    this.chartsService.loadChart(this.incidenzaChart, 'stores.Q106', data, this.indicatorService, this.translate);
    this.chartsService.loadChart(this.scontrinoMedioChart, 'stores.Q107', data, this.indicatorService, this.translate);
  }
}



// WEBPACK FOOTER //
// ./src/app/views/store/store-customers/store-customers-overview/store-customers-overview.component.ts